import { FC, useEffect, useState } from 'react';

import PortalListing from './PortalListing';
import StoresListing from './StoresListing';

const TABS = [
  {
    name: 'Portals',
    value: 'portals',
  },
  {
    name: 'Stores',
    value: 'stores',
  },
];

type SearchBoxProps = {
  showNewPortalPopup: () => void;
  showNewNetworkPopup: () => void;
  currentOption?: string;
  userId?: string;
};

const SearchBox: FC<SearchBoxProps> = ({
  showNewPortalPopup,
  showNewNetworkPopup,
  currentOption,
  userId,
}) => {
  const [currentTab, setCurrentTab] = useState<string>('portals');

  useEffect(() => {
    if (currentOption) {
      const validOption = TABS.find((option) => option.value == currentOption)?.value || TABS[0].value;
      setCurrentTab(validOption);
    }
  }, [currentOption]);

  return (
    <>
      <div className="w-full h-auto flex flex-col p-3 ">
        <div className="w-full flex gap-x-4 px-1 py-3 justify-center">
          {TABS.map((tab, index) => {
            return (
              <>
                <button
                  key={index}
                  className={`text-[18px] font-bold ${currentTab == tab.value ? 'text-blue-500 ' : ''}`}
                  onClick={() => setCurrentTab(tab.value)}
                >
                  {tab.name}
                  <div className={`w-full h-0.5 ${currentTab == tab.value ? 'bg-blue-500' : ''}`}></div>
                </button>
              </>
            );
          })}
        </div>

        <div className="w-full h-[60dvh] md:h-[400px] flex flex-col gap-y-2 p-1">
          <PortalListing
            show={currentTab == 'portals'}
            showNewPortalPopup={showNewPortalPopup}
            userId={userId}
          />

          {currentTab == 'stores' && <StoresListing userId={userId} />}
        </div>
      </div>
    </>
  );
};

export default SearchBox;
